import {
    createBrowserRouter,
    RouterProvider
} from "react-router-dom";
import {Notifications} from "@mantine/notifications";

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@flexinet/ui-components/style.css'


import {MantineProvider} from "@mantine/core";
import {AnalyticsAuthListener} from "@flexinet/analytics-components";
import {SessionGuardProvider} from "@flexinet/auth-components";
import {theme} from "./theme.ts";
import {AuthProvider} from "./providers/AuthProvider.tsx";
import {routesConfig} from "./config/routes.tsx";
import {UserAttributesProvider} from "./providers/UserAttributesProvider.tsx";
import {PermissionsProvider} from "./providers/PermissionsProvider.tsx";


const router = createBrowserRouter(routesConfig)

export const App = () => {

    return (
        <MantineProvider theme={theme} forceColorScheme="light">
            <SessionGuardProvider>
                <AuthProvider>
                    <AnalyticsAuthListener/>
                    <UserAttributesProvider>
                        <PermissionsProvider>
                            <Notifications position={'bottom-left'}/>
                            <RouterProvider router={router}/>
                        </PermissionsProvider>
                    </UserAttributesProvider>
                </AuthProvider>
            </SessionGuardProvider>
        </MantineProvider>
    )
}
